/**
 * @format
 */
import React, { useCallback, useMemo, useState } from 'react';
import {
  ActivityIndicator,
  Platform,
  Image,
  View,
  Text,
  StyleSheet,
} from 'react-native';
import FastImage from 'react-native-fast-image';
import config from '../../lib/config';

interface Props {
  imageStyle: any;
  uri: string;
  categoryName: string;
  categoryDescription?: string;
  resizeMode?: any;
}

const ThumbtackCategoryItem = (props: Props) => {
  const { imageStyle, uri, categoryName, categoryDescription } = props;
  let { resizeMode } = props;
  if (!resizeMode || Platform.OS === 'web') {
    resizeMode = 'cover';
  } else {
    resizeMode = FastImage.resizeMode.cover;
  }
  const [loading, setIsLoading] = useState(true);
  // console.log(`ZT IMAGE for ${uri}`);

  const itemImage = useMemo(() => {
    if (Platform.OS === 'web') {
      return <Image source={{ uri }} style={styles.image} {...props} />;
    } else {
      return (
        <FastImage
          source={{ uri }}
          style={styles.image}
          onLoadStart={() => {
            setIsLoading(true);
          }}
          onLoadEnd={() => {
            setIsLoading(false);
          }}
        >
          <ActivityIndicator
            animating={loading}
            size="large"
            color={'#cccccc'}
            style={imageStyle}
          />
        </FastImage>
      );
    }
  }, [uri, imageStyle, loading, props]);

  return (
    <View style={styles.mainView}>
      <View style={styles.headerView}>
        <Text style={styles.featureHeading}>{categoryName}</Text>
      </View>
      <View style={styles.bodyView}>
        <View style={styles.imageView}>{itemImage}</View>
        <View style={styles.bodyInfoView}>
          <Text style={styles.subSectionHeading}>
            {categoryDescription ? categoryDescription : categoryName}
          </Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  mainView: {
    display: 'flex',
    flexDirection: 'column',
    ...Platform.select({
      web: {
        padding: 10,
        paddingTop: 0,
      },
    }),
  },
  headerView: {
    marginBottom: 10,
    flex: 1,
    flexWrap: 'wrap',
  },
  featureHeading: {
    fontSize: config.theme.headingFontSize,
    fontWeight: config.theme.headingFontWeight,
    color: config.theme.headingTextColor,
    marginBottom: 10,
    maxWidth: '80%',
  },
  subSectionHeading: {
    fontSize: 13,
    color: config.theme.advert.subSectionHeadingTextColor,
  },
  bodyView: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 10,
  },
  imageView: {
    flex: 1,
  },
  image: {
    maxWidth: '80%',
    aspectRatio: 48 / 25,
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: 5,
    borderColor: '#CCE1FF',
  },
  bodyInfoView: {
    flex: 1,
    justifyContent: 'flex-start',
  },
});

export default ThumbtackCategoryItem;
